import { Link, useLocation } from "wouter";
import { useAuth } from "@/lib/auth";
import { Menu, X, User, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

export function PublicNav() {
  const [location] = useLocation();
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const publicLinks = [
    { label: "How it works", href: "/#how-it-works" },
    { label: "Compare", href: "/compare" },
    { label: "Benchmarks", href: "/benchmarks" },
    { label: "Pricing", href: "/pricing" },
  ];

  const authedLinks = [
    { label: "Analyze", href: "/" },
    { label: "Compare", href: "/compare" },
    { label: "History", href: "/history" },
  ];

  const links = user ? authedLinks : publicLinks;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-[#0B0D10]/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto flex h-16 items-center justify-between px-4 md:px-8">
        <div className="flex items-center gap-8">
          <Link href="/" className="flex items-center gap-2">
            <span className="font-semibold text-lg tracking-wide text-[#F5F6F7]">RESONANCE</span>
          </Link>
          
          <nav className="hidden md:flex gap-6">
            {links.map(link => (
              <Link key={link.href} href={link.href} className={`text-sm transition-colors ${location === link.href ? "text-[#F5F6F7]" : "text-[#A9B0B8] hover:text-[#F5F6F7]"}`}>
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link href="/admin" className="flex items-center gap-2 text-sm text-[#2DD4D8] hover:text-[#F5F6F7] transition-colors">
                  <ShieldCheck className="w-4 h-4" /> Control panel
                </Link>
              )}
              <Link href="/profile" className="flex items-center gap-2 text-sm text-[#A9B0B8] hover:text-[#F5F6F7] transition-colors">
                <User className="w-4 h-4" /> Account
              </Link>
            </>
          ) : (
            <>
              <Link href="/login" className="text-sm text-[#A9B0B8] hover:text-[#F5F6F7] transition-colors">Sign in</Link>
              <Button asChild className="bg-[#2DD4D8] hover:bg-[#2DD4D8]/90 text-[#0B0D10] font-medium h-9 px-4">
                <Link href="/">Try RESONANCE</Link>
              </Button>
            </>
          )}
        </div>

        <button className="md:hidden text-[#A9B0B8] p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-white/5 bg-[#0B0D10] px-4 py-4 space-y-4">
          <nav className="flex flex-col gap-4">
            {links.map(link => (
              <Link key={link.href} href={link.href} onClick={() => setMobileMenuOpen(false)} className={`text-base font-medium ${location === link.href ? "text-[#F5F6F7]" : "text-[#A9B0B8]"}`}>
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="pt-4 border-t border-white/5 flex flex-col gap-4">
            {user ? (
              <>
                {user.role === "admin" && (
                  <Link href="/admin" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 text-base font-medium text-[#2DD4D8]">
                    <ShieldCheck className="w-4 h-4" /> Control panel
                  </Link>
                )}
                <Link href="/profile" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 text-base font-medium text-[#A9B0B8]">
                  <User className="w-4 h-4" /> Account
                </Link>
              </>
            ) : (
              <>
                <Link href="/login" onClick={() => setMobileMenuOpen(false)} className="text-base font-medium text-[#A9B0B8]">Sign in</Link>
                <Button asChild className="bg-[#2DD4D8] hover:bg-[#2DD4D8]/90 text-[#0B0D10] font-medium w-full">
                  <Link href="/" onClick={() => setMobileMenuOpen(false)}>Try RESONANCE</Link>
                </Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
